<template>
    <b-form-row>
        <b-modal @hidden="ataSelect" v-model="showModal" size="xl" button-size="md" ref="finder" hide-footer
            :id="this.id" :title="prefix + title">
            <Ata-List :processoCompra="processoCompra" @close="ataSelect" :title="prefix + title" />
        </b-modal>

        <lg-form-input-finder v-if="!isModal" :value="computedValue" @input="updateValue" fieldDescription="numeroAta"
            :label="label" invalidFeedback="Ata deve ser informado!" description="" @handleClean="ataSelect"
            :showClear="podeApagar" :disabled="disabled">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed v-if="podeMudar" :disabled="disabled">
                    <b-icon icon="search" />
                </b-button>
            </template>

        </lg-form-input-finder>

    </b-form-row>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import AtaList from "@/modules/ata-registro-preco/ConsultarAtas.vue"

export default {
    components: {
        LgFormInputFinder,
        AtaList,
    },

    props: {
        isModal: {
            type: Boolean,
            default: false
        },

        processoCompra: {
            type: Object,
            default: null
        },

        apenasAtivos: {
            type: Boolean,
            default: false
        },
        id: String,
        onDblClickAtaList: Function,
        value: Object,
        departamento: Object,
        podeMudar: {
            type: Boolean,
            default: true,
        },
        podeApagar: {
            type: Boolean,
            default: true,
        },
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Ata:"
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Ata",
        },

    },


    data() {
        return {
            showModal: this.isModal ? true : false,

            localObject: this.value || {},
            ata: "",
            fields: [
                {
                    key: "nome",
                    label: "Nome",
                    thClass: "pt-1 pb-0",
                    tdClass: "py-0 text-center col-1",
                },
            ],
        }
    },
    watch: {
        value(newValue) {
            this.computedValue = newValue;
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.localObject
            },
            set(newValue) {
                this.localObject = newValue
            },
        },
    },
    methods: {

        async show() {
            await this.$refs.finder.show()
            this.$bvModal.show(this.id)
        },
        updateValue(newValue) {
            this.computedValue = newValue
            this.$emit("input", newValue)
        },
        async ataSelect(item) {
            this.computedValue = item
            this.$emit("input", this.localObject)
            await this.$bvModal.hide(this.id)
        },
    },
}
</script>
